export function findForemanAssignmentId(assignments) {
    let id = null;

    assignments.every(assignment => {
        if (assignment.crewMember.classification === 'F') { 
            id = assignment.id;
            return false;
        }
        return true;
    });
    
    // Fallback: if no foreman found, use first assignment
    if (id === null && assignments.length > 0) {
        id = assignments[0].id;
    }
    
    return id;
}

export function createSplitJobDaySubmitData(assignments, days) {
    let data = {};
    let allDays = {};

    let allAssignments = {
        A: [],
        B: [],
        C: []
    };

    assignments.forEach(assignment => {
        if (assignment.option) {
            allAssignments[assignment.option].push({
                id: parseInt(assignment.id, 10)
            });
        }
    });

    days.forEach(day => {
        allDays[day.jobDay] = {
            id: parseInt(day.id, 10),
            scope: day.scope,
            assignments: [...allAssignments[day.jobDay]]
        };
    });

    data['days'] = [...Object.keys(allDays).map(dayKey => {
        return { ...allDays[dayKey] };
    })];

    return data;
}
